class ModalDialogLauraJames extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.querySelector('.product-media-modal__close').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog-laurajames', ModalDialogLauraJames);

class SliderComponentLaurajames extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.siderSliderNav = this.querySelector('.side-slider-nav')

    // Store initial hidden state
    this.navStartsHidden = this.siderSliderNav && this.siderSliderNav.classList.contains('hidden');

    // Get drag sensitivity from attribute, default to 0.3 (30% of slide width)
    this.dragSensitivity = parseFloat(this.getAttribute('drag-sensitivity')) || 0.3;

    if (!this.slider || !this.nextButton) return;

    // Tracking properties
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.velocity = 0;
    this.lastX = 0;
    this.lastTime = 0;
    this.isScrolling = false;

    this.initPages();
    this.initSlider();
    this.initScrollIndicator();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'style') {
          this.updateVisibleItemCount();
        }
      });
    });

    this.sliderItems.forEach(item => {
      observer.observe(item, { attributes: true });
    });

    const resizeObserver = new ResizeObserver((entries) => {
      this.initPages();
      this.initSlider();
      this.toggleVisibilitySideSlideNav();
      this.initScrollIndicator();
    });
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.scrollToActiveSlide();
  }

  scrollToActiveSlide() {
    if (!this.classList.contains('color-swatch-slider')) return;

    const activeItem = this.slider.querySelector('.active');
    if (!activeItem) return;

    const activeSlide = activeItem.closest('[id^="Slide-"]');
    if (!activeSlide) return;

    this.slider.scrollLeft = activeSlide.offsetLeft;
    this.update();
  }

  initScrollIndicator() {
    this.scrollIndicator = this.querySelector('.slider-scroll-indicator');
    this.scrollContainer = this.querySelector('.slider-scroll-indicator-container');
    
    if (!this.scrollIndicator || !this.scrollContainer || !this.slider) return;

    // Store initial hidden state
    if(this.scrollContainerStartsHidden === undefined){
      this.scrollContainerStartsHidden = this.scrollContainer.classList.contains('hidden');
    }

    // Calculate scrollable positions first
    this.updateScrollIndicator();
    
    // Hide indicator if there's nothing to scroll (only 1 position)
    if (this.scrollablePositions <= 1) {
      if(this.scrollContainerStartsHidden){
        this.scrollContainer.classList.add('hidden');
      } else {
        this.scrollContainer.style.display = 'none';
      }
      return;
    } else {
      if(this.scrollContainerStartsHidden){
        this.scrollContainer.classList.remove('hidden');
      } else {
        this.scrollContainer.style.display = '';
      }
    }
    
    setTimeout(() => {
      this.updateScrollIndicator();
    }, 100);
    
    // Use the actual scroll event as the primary update trigger
    this.slider.addEventListener('scroll', () => {
      requestAnimationFrame(() => this.updateScrollIndicator());
    });
    
    // Update on resize
    window.addEventListener('resize', () => {
      this.updateScrollIndicator();
    });
  }
  
  updateScrollIndicator() {
    if (!this.scrollIndicator || !this.slider) return;
    
    const slideCount = this.sliderItemsToShow?.length || this.sliderItems?.length || 1;
    
    // Check if all content is visible (no scrolling needed)
    const totalScrollWidth = this.slider.scrollWidth - this.slider.clientWidth;
    if (totalScrollWidth <= 0) {
      // All content is visible, hide indicator
      this.scrollablePositions = 1;
      return;
    }
    
    // Calculate actual visible slides more accurately
    const visibleSlides = Math.floor(this.slider.clientWidth / this.sliderItemOffset) || 1;
    const scrollablePositions = Math.max(1, slideCount - visibleSlides + 1);
    
    // Set width based on scrollable positions
    this.scrollIndicator.style.width = `${100 / scrollablePositions}%`;
    
    // Calculate and set position
    const scrollPercentage = this.slider.scrollLeft / totalScrollWidth;
    const maxPosition = 100 * (scrollablePositions - 1);
    const position = Math.max(0, Math.min(scrollPercentage * maxPosition, maxPosition));
    this.scrollIndicator.style.transform = `translateX(${position}%)`;
    
    // Store scrollablePositions for hide logic
    this.scrollablePositions = scrollablePositions;
  }


  initSlider() {
    if(this.isTouchDevice()) return;

    this.sliderItems.forEach(item => {
      const images = item.querySelectorAll('img');
      images.forEach(img => img.setAttribute('draggable', 'false'));
    });

    this.handleDragStart = this.dragStart.bind(this);
    this.handleDragMove = this.dragMove.bind(this);
    this.handleDragEnd = this.dragEnd.bind(this);
    this.handleClick = this.preventClick.bind(this);

    this.slider.addEventListener('mousedown', this.handleDragStart);
    window.addEventListener('mousemove', this.handleDragMove);
    window.addEventListener('mouseup', this.handleDragEnd);
    window.addEventListener('mouseleave', this.handleDragEnd);
  }

  dragStart(e) {
    if (e.target.nodeName === 'VIDEO') {
      const video = e.target;
      this.videoTarget = video;
      this.videoStartTime = video.currentTime;
      this.videoStartVolume = video.volume;
      this.videoControlChecked = false;
    } else {
      this.videoTarget = null;
    }
    
    this.isDragging = true;
    this.hasMoved = false;
    this.startX = e.pageX;
    this.startScrollLeft = this.slider.scrollLeft;

    this.slider.style.cursor = 'grabbing';
    this.slider.classList.add('dragging');
    this.slider.style.scrollBehavior = 'auto';

    if (!this.videoTarget) {
      e.preventDefault();
    }
  }

  dragMove(e) {
    if (!this.isDragging) return;

    if (this.videoTarget && !this.videoControlChecked) {
      const video = this.videoTarget;
      const timeChanged = Math.abs(video.currentTime - this.videoStartTime) > 0.5;
      const volumeChanged = Math.abs(video.volume - this.videoStartVolume) > 0.01;
      
      if (timeChanged || volumeChanged) {
        this.isDragging = false;
        this.slider.style.cursor = 'grab';
        this.slider.classList.remove('dragging');
        this.videoTarget = null;
        return;
      }
    }

    const x = e.pageX;
    const walk = this.startX - x;

    //Check if the user has moved the mouse more than 5 pixels horizontally. If so, set hasMoved to true and check if the user is interacting with the video controls.
    if (Math.abs(walk) > 5) {
      this.hasMoved = true;
      if (this.videoTarget) {
        this.videoControlChecked = true;
        e.preventDefault();
      }
    }

    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    let newScrollPosition = this.startScrollLeft + walk;

    // Only apply boundary at the start (left side)
    newScrollPosition = Math.max(0, newScrollPosition);

    // For the end (right side), allow slight overscroll for smoother feel
    if (newScrollPosition > maxScroll) {
      const overscroll = newScrollPosition - maxScroll;
      newScrollPosition = maxScroll + Math.min(overscroll * 0.5, 50);
    }

    this.slider.scrollLeft = newScrollPosition;
  }

  dragEnd(e) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.slider.style.cursor = 'grab';
    this.videoTarget = null;

    if (this.hasMoved) {
      e.preventDefault();
      e.stopPropagation();

      const currentScroll = this.slider.scrollLeft;
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      const dragDistance = currentScroll - this.startScrollLeft;
      const dragPercentage = Math.abs(dragDistance) / this.sliderItemOffset;
      const direction = dragDistance > 0 ? 1 : -1;
      
      let targetPosition;
      
      const effectiveSensitivity = (direction > 0 && currentScroll >= maxScroll - 10) ? 0.05 : this.dragSensitivity;
      
      if (dragPercentage >= effectiveSensitivity) {
        // Calculate target based on start position and intended movement
        const startIndex = Math.round(this.startScrollLeft / this.sliderItemOffset);
        const slidesToMove = Math.max(1, Math.floor(dragPercentage));
        const targetIndex = startIndex + (direction * slidesToMove);
        
        // Ensure target is within bounds
        const boundedTargetIndex = Math.max(0, Math.min(targetIndex, this.sliderItems.length - 1));
        targetPosition = boundedTargetIndex * this.sliderItemOffset;
        
        // Allow maxScroll for last item to show full content
        if (boundedTargetIndex === this.sliderItems.length - 1 && direction > 0) {
          targetPosition = Math.max(targetPosition, maxScroll);
        } else {
          targetPosition = Math.min(targetPosition, maxScroll);
        }
        
        // Anti-snapback: if dragging too much causes backward movement, snap to nearest forward position
        if ((direction > 0 && targetPosition < currentScroll) || 
            (direction < 0 && targetPosition > currentScroll)) {
          const currentIndex = Math.round(currentScroll / this.sliderItemOffset);
          const nextIndex = direction > 0 ? 
            Math.min(currentIndex + 1, this.sliderItems.length - 1) : 
            Math.max(currentIndex - 1, 0);
          
          if (nextIndex === this.sliderItems.length - 1 && direction > 0) {
            targetPosition = Math.max(nextIndex * this.sliderItemOffset, maxScroll);
          } else {
            targetPosition = Math.min(nextIndex * this.sliderItemOffset, maxScroll);
          }
        }
      } else {
        // If drag was less than sensitivity threshold, snap back to starting slide
        const startIndex = Math.round(this.startScrollLeft / this.sliderItemOffset);
        
        // Allow maxScroll if dragging right and close to maxScroll
        if (direction > 0 && currentScroll >= maxScroll - 10) {
          targetPosition = maxScroll;
        } else {
          targetPosition = Math.min(startIndex * this.sliderItemOffset, maxScroll);
        }
      }
      
      // Stop any current scrolling and reset behavior before applying new scroll
      this.slider.style.scrollBehavior = '';
      this.slider.scrollLeft = this.slider.scrollLeft; // Force stop current momentum
      
      // Small delay to ensure the above takes effect
      setTimeout(() => {
        this.slider.style.scrollBehavior = 'smooth';
        this.slider.scrollLeft = targetPosition;
      }, 10);

      this.slider.addEventListener('click', this.handleClick, {
        capture: true,
        once: true
      });
    } else {
      this.slider.style.scrollBehavior = 'smooth';
    }

    this.slider.classList.remove('dragging');
    this.update();
  }

  preventClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  disconnectedCallback() {
    this.slider.removeEventListener('mousedown', this.handleDragStart);
    window.removeEventListener('mousemove', this.handleDragMove);
    window.removeEventListener('mouseup', this.handleDragEnd);
    window.removeEventListener('mouseleave', this.handleDragEnd);
    this.slider.removeEventListener('click', this.handleClick, true);
  }

  isTouchDevice() {
    return (
        'ontouchstart' in window || // Works for most modern browsers
        navigator.maxTouchPoints > 0 || // Works for newer versions
        (window.DocumentTouch && document instanceof DocumentTouch) // Works for older WebKit browsers
    );
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => {
      return element.clientWidth > 0 && getComputedStyle(element).display !== 'none';
    });

    // Handle single item case
    if (this.sliderItemsToShow.length <= 1) {
      this.sliderItemOffset = this.slider.clientWidth;
      this.slidesPerPage = 1;
      this.totalPages = 1;
      this.update();
      return;
    }

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    // Ensure we have a valid offset
    if (!this.sliderItemOffset) {
      this.sliderItemOffset = this.slider.clientWidth;
    }

    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  updateVisibleItemCount() {
    // Get all slider items
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    
    const visibleItems = Array.from(this.sliderItems).filter(
      item => getComputedStyle(item).display !== 'none'
    );

    if (this.pageTotalElement) {
      this.pageTotalElement.textContent = visibleItems.length;
    }

    this.totalPages = visibleItems.length;
    this.update();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;

    // Handle single item case
    if (this.sliderItemsToShow.length <= 1) {
      this.currentPage = 1;
    } else {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      if (!this.pageTotalElement.textContent) {
        this.pageTotalElement.textContent = this.totalPages;
      }
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    // Disable buttons appropriately for single item
    if (this.sliderItemsToShow.length <= 1) {    
      this.prevButton.setAttribute('disabled', 'disabled');
      this.nextButton.setAttribute('disabled', 'disabled');

      //Hide slider buttons on complementary products when there is only one product or none to show
      const complementarySliderButtons = document.querySelector('.complementary-products__container .slider-buttons');
      
      if(complementarySliderButtons){
        this.prevButton.style.display = 'none';
        this.nextButton.style.display = 'none';
      }else{
        this.prevButton.style.display = '';
        this.nextButton.style.display = '';
      }
      
      return;
    }

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    if (!element || getComputedStyle(element).display === 'none') return false;

    // Add a small tolerance value for iOS
    const tolerance = 5; // pixels

    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= (lastVisibleSlide + tolerance) && 
           element.offsetLeft >= (this.slider.scrollLeft - tolerance);
  }

  onButtonClick(event) {
    event.preventDefault();
    this.updateScrollIndicator();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });

    //update scroll indicator
    setTimeout(() => this.updateScrollIndicator(), 50);
  }

  updateCounter() {
    this.updateVisibleItemCount();
  }

  toggleVisibilitySideSlideNav(){
    if(!this.siderSliderNav) return;

    if(this.navStartsHidden){
      if(this.prevButton.disabled && this.nextButton.disabled){
        this.siderSliderNav.classList.add('hidden');
      }else{
        this.siderSliderNav.classList.remove('hidden');
      }
    }
  }
}

customElements.define('slider-component-laurajames', SliderComponentLaurajames);

function toggleImages() {
  for (var i = 0; i < productImages.length; i++) {
    if (i < visibleImages) {
      productImages[i].style.display = 'block';
    } else {
      productImages[i].style.display = 'none';
    }
  }

  const sliders = document.querySelectorAll('slider-component-laurajames');
  sliders.forEach(slider => {
    if (typeof slider.updateCounter === 'function') {
      slider.updateCounter();
    }
  });
}

class ComplementaryProductsRecommendations extends HTMLElement {
  constructor() {
    super();
    
  }

  connectedCallback() {
    this.fetchAndUpdateRecommendations();
  
    // Add event listener for refresh:complementary-products
    this.refreshHandler = () => {
      this.fetchAndUpdateRecommendations(true);
    };
  
    document.addEventListener('refresh:complementary-products', this.refreshHandler);
  }

    disconnectedCallback() {
      if (this.refreshHandler) {
        document.removeEventListener('refresh:complementary-products', this.refreshHandler);
      }
    }

  fetchAndUpdateRecommendations(isRefresh = false){
    fetch(this.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('complementary-products-recommendations');

      if (!recommendations || !recommendations.querySelector('aside') || !recommendations.querySelector('.complementary-card__container')) {
        this.classList.add('hidden');
        return;
      }
      
      this.classList.remove('hidden');

      const existingContainer = this.querySelector('.complementary-card__container');

      if (!existingContainer) {
        this.innerHTML = recommendations.innerHTML;
        return;
      }

      const existingProducts = this.querySelectorAll('.complementary-card__container .complementary-card__product');

      if (!isRefresh || existingProducts.length === 0) {
        this.innerHTML = recommendations.innerHTML;
        return;
      }else{
        const existingProductsIds = new Set();
        
        existingProducts.forEach(existingProduct => {
          const variant_id = existingProduct.querySelector('.checkbox-input').getAttribute('data-variant-id')
          if(variant_id) {
            existingProductsIds.add(variant_id)
          }
        });

        const newProductContainer = recommendations.querySelector('.complementary-card__container');
        const newProducts = newProductContainer.querySelectorAll('.complementary-card__product')

        let hasAddedProduct = false;

        newProducts.forEach(newProduct => {
          const variant_id = newProduct.querySelector('.checkbox-input').getAttribute('data-variant-id')
          if(!existingProductsIds.has(variant_id)){
            existingContainer.prepend(newProduct.cloneNode(true));
            hasAddedProduct = true;
          }
        });

        if(hasAddedProduct){
          const slider = this.querySelector('slider-component-laurajames.complementary-products__container');
          if (slider) {
            // Save reference to the slider's parent
            const parent = slider.parentNode;
            // Get next sibling for proper insertion
            const nextSibling = slider.nextSibling;
            
            // Create a new container to hold the slider's content
            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = slider.outerHTML;
            
            // Get the new slider element
            const newSlider = tempContainer.firstElementChild;
            
            // Remove the old slider
            parent.removeChild(slider);
            
            // Wait a bit for the DOM to update
            setTimeout(() => {
              // Insert the new slider at the same position
              if (nextSibling) {
                parent.insertBefore(newSlider, nextSibling);
              } else {
                parent.appendChild(newSlider);
              }
              
              // Let the browser process this change
              setTimeout(() => {
                // Get the new slider reference
                const refreshedSlider = this.querySelector('slider-component-laurajames.complementary-products__container');
                
                // Initialize the new slider
                if (refreshedSlider && typeof refreshedSlider.connectedCallback === 'function') {
                  refreshedSlider.connectedCallback();
                } else if (refreshedSlider) {
                  // Fallback to individual methods
                  if (typeof refreshedSlider.initPages === 'function') {
                    refreshedSlider.initPages();
                  }
                  if (typeof refreshedSlider.initSlider === 'function') {
                    refreshedSlider.initSlider();
                  }
                  if (typeof refreshedSlider.initScrollIndicator === 'function') {
                    refreshedSlider.initScrollIndicator();
                  }
                }
              }, 100);
            }, 100);
          }
        }

      }

      if (html.querySelector('.grid__item')) {
        this.classList.add('product-recommendations--loaded');
      }
    })
    .catch((e) => {
      console.error(e);
    });
  }
}

customElements.define('complementary-products-recommendations', ComplementaryProductsRecommendations);